<template>
    <rkm-overlay>
        <rkm-layout-body title="Escolher veículo">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.List.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List ref="List" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/escolher/List'

// Vuex.
import { mapActions } from 'vuex';

export default {
    components: { List },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        handleExit() {
            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        redirectToList() {
            this.$router.push({ name: 'dashboard' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
        },
    },
}
</script>